<template>
  <div class="ac-body-container">
    <div class="i-c-item">
      <div class="d-flex flex-column">
        <div class="header">Temperature</div>
        <div class="i-c-container">
          <input
            id="temp-fahrenheit"
            name="temp-fahrenheit"
            type="radio"
            class="i-radio"
            :checked="temperature === '°F'"
            @change="onChange('temperature', '°F')"
          />
          <label class="label" for="temp-fahrenheit"> Fahrenheit (°F) </label>
        </div>
        <div class="i-c-container">
          <input
            id="temp-celsius"
            type="radio"
            class="i-radio"
            :checked="temperature === '°C'"
            @change="onChange('temperature', '°C')"
          />
          <label class="label" for="temp-celsius"> Celsius (°C) </label>
        </div>
      </div>
    </div>
    <div class="i-c-item">
      <div class="d-flex flex-column">
        <div class="header">Date Format</div>
        <div class="i-c-container">
          <input
            id="date-month"
            type="radio"
            class="i-radio"
            :checked="dateFormat === 'MM-DD-YYYY'"
            @change="onChange('dateFormat', 'MM-DD-YYYY')"
          />
          <label class="label" for="date-month"> MM/DD/YYYY </label>
        </div>
        <div class="i-c-container">
          <input
            id="date-day"
            type="radio"
            class="i-radio"
            :checked="dateFormat === 'DD-MM-YYYY'"
            @change="onChange('dateFormat', 'DD-MM-YYYY')"
          />
          <label class="label" for="date-day"> DD/MM/YYYY </label>
        </div>
      </div>
    </div>
    <div class="i-c-item">
      <div class="d-flex flex-column">
        <div class="header">Distance</div>
        <div class="i-c-container">
          <input
            id="dist-mi"
            type="radio"
            class="i-radio"
            :checked="distance === 'mi'"
            @change="onChange('distance', 'mi')"
          />
          <label class="label" for="dist-mi"> Miles (mi) </label>
        </div>
        <div class="i-c-container">
          <input
            id="dist-km"
            type="radio"
            class="i-radio"
            :checked="distance === 'km'"
            @change="onChange('distance', 'km')"
          />
          <label class="label" for="dist-km"> Kilometers (km) </label>
        </div>
      </div>
    </div>
    <div class="i-c-item">
      <div class="d-flex flex-column">
        <div class="header">Pressure</div>
        <div class="i-c-container">
          <input
            id="pressure-in"
            type="radio"
            class="i-radio"
            :checked="pressure === 'inH2O'"
            @change="onChange('pressure', 'inH2O')"
          />
          <label class="label" for="pressure-in"> Inch of Water (inH2O) </label>
        </div>
        <div class="i-c-container">
          <input
            id="pressure-pa"
            type="radio"
            class="i-radio"
            :checked="pressure === 'Pa'"
            @change="onChange('pressure', 'Pa')"
          />
          <label class="label" for="pressure-pa"> Pascals (Pa) </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreferencesSettings',
  props: {
    temperature: String,
    dateFormat: String,
    distance: String,
    pressure: String,
    onChange: Function,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 16px;
  font-weight: 500;
}
.sub-header {
  font-size: 14px;
  color: $N40;
}

.i-c-item {
  border: 1px solid #c4c5cc;
  display: flex;
  flex-direction: row;
  padding: 20px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  justify-content: space-between;
}

.i-c-container {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 10px;
  align-items: baseline;
  padding: 20px 5px 0 5px;
  cursor: pointer;

  .label {
    font-size: 1rem;
    font-weight: 600;
    color: $N70;
  }
}

.body {
  font-size: 0.875rem;
  margin-top: 8px;
  margin-bottom: 8px;
  color: $N80;
}

.pc-home-img {
  height: 520px;
}
.pc-noc-img {
  width: 380px;
  border-radius: 8px;
}
.pc-noc-img-big {
  width: 480px;
  border-radius: 8px;
}
.pc-preview-background {
  border-radius: 50px;
}
.pc-preview-title {
  margin-top: 10px;
  text-align: center;
}
</style>
